import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"
import { Dropdown } from "bootstrap"
import { loadRunner } from "../guides/load_runner"

// The desktop tour points at the sidebar, which is hidden below 992 px (components/_navigation.scss); the phone
// welcome is for exactly those screens.
const MEDIA = { desktop: "(min-width: 992px)", phone: "(max-width: 991.98px)" }

// Starts an in-app guide whose config the server rendered into the page (Guides::Payload). A page can carry two,
// the desktop tour and the phone welcome; each element names its media, and only the one that matches the screen
// starts. The guide itself is its own bundle (guide_runner.js with Driver.js, or guide_sheet.js): this stub is all
// application.js carries, and a bundle is fetched only on pages that render its element, for users who still have
// something to see.
export default class extends Controller {
  static values = { config: Object, runner: String, media: { type: String, default: "desktop" } }

  // The config in this element is only true for this visit. Turbo caches the page as it is when the user leaves
  // it, so take the element out of the snapshot, whether or not the tour runs on this screen.
  cacheHandler = () => this.element.remove()

  connect() {
    document.addEventListener("turbo:before-cache", this.cacheHandler)
    if (!window.matchMedia(MEDIA[this.mediaValue] ?? MEDIA.desktop).matches) return

    // Each connect has its own token, so a runner that arrives after the element left (or after it came back and
    // asked again) is ignored.
    const token = {}
    this.token = token
    // A failed load is left unhandled on purpose: it reaches error monitoring (frontend/stimulus-controllers.md §1).
    loadRunner(this.runnerValue).then(({ GuideRunner }) => {
      if (this.token !== token) return

      this.runner = new GuideRunner({ element: this.element, config: this.configValue, Dropdown, visit })
      this.runner.connect()
    })
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.cacheHandler)
    this.token = null
    this.runner?.disconnect()
    this.runner = null
  }
}
